import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import Button from '../../../../../App/Components/Button/Button'
import Modal from '../../../../../App/Components/Modal/Modal'
import { useAppDispatch } from '../../../../../App/Hooks/reduxHooks'
import { deleteQuestion } from '../../../Store/Action'
import style from '../cardStyle.scss'

type EditQuestionCardModalProp = {
  modalState: boolean
  setModalState: (state: boolean) => void
  passQuestionId: string
}
export const EditQuestionCardModal = ({
  modalState,
  setModalState,
  passQuestionId,
}: EditQuestionCardModalProp) => {
  const { surveyId } = useParams<{ [key: string]: string }>()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const questionDetails = { surveyId, questionId: passQuestionId }

  const confirmDelete = () => {
    dispatch(deleteQuestion(questionDetails))
    setModalState(false)
  }

  return (
    <Modal
      modalState={modalState}
      setModalState={state => setModalState(state)}
      modalTitle={t('Delete Question')}>
      <div>
        <p>{t('Are you sure you want to delete this question?')}</p>
      </div>
      <div className={style.modalButtons}>
        <Button onClick={() => setModalState(false)}>{t('Cancel')}</Button>
        <Button color={'#333'} onClick={() => confirmDelete()}>
          {t('Delete')}
        </Button>
      </div>
    </Modal>
  )
}
